// src/index.ts
import { extendBaseTheme } from "@stepstone-genesis/dresscode-base";
import { emedcareers as baseEmedcareersTheme } from "@stepstone-genesis/design-tokens";
var emedcareers = extendBaseTheme("emedcareers", baseEmedcareersTheme);
export {
  emedcareers
};
